export default __webpack_public_path__ + "static/Averta-Regular-8cc63af581eeb5a1436efc168b655e31.woff";